// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 508) return "static/chunks/f69bbb46-392c95dc4438b5e3.js";
	if (chunkId === 703) return "static/chunks/0270f06d-d5bafe31f0b03557.js";
	if (chunkId === 597) return "static/chunks/next-a001631fe7796742.js";
	if (chunkId === 168) return "static/chunks/168-bf38cc31e725f1f6.js";
	if (chunkId === 652) return "static/chunks/652-123b37446999aba8.js";
	if (chunkId === 1) return "static/chunks/1-4a8793d325862204.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"60":"1d3106e1fdc5856a","69":"ee37e697f7c1f0cd","201":"eadb0b0e40aef457","359":"01d5e8a5b78b9405","434":"56a6d7a2b0802efa","457":"104b8fd23be0c9b9","489":"bbb299b324305c0a","580":"804438ea9c14cca4","668":"582ee06d13baf873","877":"605a2ccb580efd7d","885":"851addfbc4fc9ea7"}[chunkId] + ".js";
};